module.exports = __webpack_public_path__ + "img/diffLevel.ae365b53.svg";